// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2KvNq","inputDescription":"styles_inputDescription__15u4N"};